import { render } from "./TenDLCDisabledBanner.vue?vue&type=template&id=a50db1d2"
import script from "./TenDLCDisabledBanner.vue?vue&type=script&lang=js"
export * from "./TenDLCDisabledBanner.vue?vue&type=script&lang=js"

import "./TenDLCDisabledBanner.vue?vue&type=style&index=0&id=a50db1d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__